import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import AboutSchool from "./pages/AboutSchool";
import Contact from "./pages/Contact";
import Oops from "./pages/Oops";
import Facilities from "./pages/Facilities";
import HowToApply from "./pages/HowToApply";
import Gallery from "./pages/Gallery";
import News from "./pages/News";
import NewsPage from "./pages/NewsPage";
import AboutPrincipal from "./pages/AboutPrincipal";
import AboutChairman from "./pages/AboutChairman";
import Registration from "./pages/Registration";
import StudentForm from "./pages/Form";
import Overview from "./pages/Overview";
import Register from "./pages/Register";
import AboutMath from "./pages/AboutMath";

function App() {
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: "USER_LOADING" });
    // dispatch(loadUser());
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  if (state.auth.loginFailed) {
    // navigate("/", { replace: true });
    // dispatch({ type: "RESET_REDIRECT_LOGIN" });
  }

  function handleWindowSizeChange() {
    console.log(window.innerWidth);
    if (window.innerWidth <= 1300) {
      dispatch({ type: "MOBILE_VIEW", payload: true });
    } else {
      dispatch({ type: "MOBILE_VIEW", payload: false });
    }
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/about_math" element={<AboutMath />} />
      <Route path="/about_principal" element={<AboutPrincipal />} />
      <Route path="/facilities" element={<Facilities />} />
      <Route path="/about_school" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/how_to_apply" element={<HowToApply />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/news_and_events" element={<News />} />
      <Route path="/news" element={<NewsPage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/admission_form" element={<Registration />} />
      <Route path="/view_form" element={<StudentForm />} />
      <Route path="/overview" element={<Overview />} />

      <Route path="*" element={<Oops />} />
    </Routes>
  );
}

export default App;
